type JumpComment = {
    _id: string;
    isReply?: () => boolean;
};

export const MESSAGE_JUMP_RAIL_MIN_COUNT = 2;
export const ACTIVITY_PREVIEW_MIN_ITEMS = 10;
export const ACTIVITY_PREVIEW_MAX_ITEMS = 50;

function isTimelineMessage(item: unknown): boolean {
    if (!item || typeof item !== 'object')
        return false;
    return typeof (item as JumpComment).isReply === 'function';
}

export function commentsForJumpRail<T>(items: T[]): Array<T & JumpComment> {
    return (items || []).filter((item): item is T & JumpComment => isTimelineMessage(item));
}

export function shouldShowMessageJumpRail(count: number): boolean {
    return count >= MESSAGE_JUMP_RAIL_MIN_COUNT;
}

/**
 * Preview length for a newest-first activity timeline: at least `minItems`,
 * extended until the first message is included, capped at `maxItems`.
 */
export function activityPreviewLimit(
    items: unknown[],
    options?: { minItems?: number; maxItems?: number },
): number {
    const minItems = options?.minItems ?? ACTIVITY_PREVIEW_MIN_ITEMS;
    const maxItems = options?.maxItems ?? ACTIVITY_PREVIEW_MAX_ITEMS;
    const list = items || [];
    if (list.length === 0)
        return 0;

    const base = Math.min(minItems, list.length);
    const firstMessageIndex = list.findIndex(isTimelineMessage);
    if (firstMessageIndex < 0)
        return base;

    const withMessage = Math.max(base, firstMessageIndex + 1);
    return Math.min(withMessage, maxItems, list.length);
}

export function isMessageInPreview(
    items: Array<{ _id?: string }>,
    id: string,
    showAll: boolean,
    previewLimit?: number,
): boolean {
    const limit = previewLimit ?? activityPreviewLimit(items);
    const preview = showAll ? items : items.slice(0, limit);
    return preview.some((item) => item?._id === id);
}
